import { Box, Typography, IconButton, ButtonBase } from "@mui/material";
import { useAuth } from "../../auth/AuthContext";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import AddCallIcon from "@mui/icons-material/AddCall";
import EmailIcon from "@mui/icons-material/Email";

import teamPatern from '../../assets/icons/teams/pattern.png'
import Footer from "../home/Footer";

const UserProfile = () => {
    const [ourTeam, setOurTeam] = useState([]);
    const [allTeam, setAllTeam] = useState([]);
    const [error, setError] = useState(null);
    const [params, setParams] = useState(null);
    const [loading, setLoading] = useState(true);
    const { getData } = useAuth();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        async function fetchData() {
            try {
                setLoading(true);
                setError(null);
                const uuid = searchParams.get('ui');
                setParams(uuid);
        
                const response = await getData("proccess.php", "staffs"); // Fetch adverts data
                if (response.success) {
                    const allTeams = response.data.filter((team) =>
                        team.Id !== 36 &&
                        team.status === "active"
                    );
                    setAllTeam(allTeams);
                    const otherTeams = response.data.find((team) => team.Id == uuid && team.status === "active");
                    setOurTeam(otherTeams);
                } else {
                console.error(response.message || "Failed to load adverts data");
                }
        
            } catch (err) {
                console.error("Fetch error:", err);
                setError("Failed to load data. Please try again later.");
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, [getData, searchParams]); // Added dependency array

    return(
        <>
            <div style={{
                width: '100%',
                minHeight: '50vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'start',
            }}>
                <Box sx={{
                    width: '100%',
                    height: 'auto',
                    margin: '4rem 0 0 0',
                    backgroundColor: '#abe4bfff',
                    overflow: 'hidden',
                    paddingTop: '4rem'
                }}>
                    <Box sx={{
                        width: '100%',
                        height: '100%',
                        backgroundImage: `url(${teamPatern})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                        display: 'flex',
                        flexFlow: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '1rem'
                    }}>
                        <Box flex={1} minWidth={'300px'} maxWidth={"1200px"} display={'flex'} alignItems={'center'} justifyContent={'center'} gap={'1rem'}>
                            <Box width={{xs: '70px', sm: '150px'}} height={{xs: '70px', sm: '150px'}} sx={{borderRadius: '50%', backgroundColor: '#e7f1f5'}} overflow={'hidden'}>
                                <img 
                                    src={`https://mindsinaction.com.na/assets/media/pictures/${ourTeam.image}`} 
                                    alt={ourTeam.FirstName}
                                    style={{
                                        width: '100%'
                                    }}
                                />
                            </Box>
                            <Box flex={1}>
                                <h1
                                    className="primary-header"
                                    style={{ color: "#ffffffff", margin: "0" }}
                                >
                                    {ourTeam.FirstName} {ourTeam.LastName}
                                </h1>
                                <Typography variant="h6" fontWeight={700} maxWidth={'400px'} color="#585858ff" dangerouslySetInnerHTML={{ __html: ourTeam.role_explanation }}/>
                                <Box >
                                    <IconButton href={`mailto:${ourTeam.email}`} sx={{backgroundColor: '#fff', margin: '0 .5rem 0 0'}}>
                                        <Typography sx={{color: '#3b76b2'}}><EmailIcon /></Typography>
                                    </IconButton>
                                    <IconButton href={`tel:+264${ourTeam.Cell}`} sx={{backgroundColor: '#fff'}}>
                                        <Typography color="#3b76b2"><AddCallIcon /></Typography>
                                    </IconButton>
                                </Box>
                            </Box>
                        </Box>
                        <Box width={{xs: '100%', sm: '300px'}} height={'auto'} sx={{backgroundColor: '#fff'}} borderRadius={'1rem'} padding={'1rem'}
                            marginTop={{xs: '1rem', sm: 'none'}}>
                            <Typography 
                                sx={{
                                    padding: '1rem',
                                    background: 'linear-gradient( to right, #3b76b2, transparent)'
                                }} fontWeight={700} color="#fff"
                            >PASSION</Typography>
                            <Typography
                                dangerouslySetInnerHTML={{ __html: ourTeam.passion }}
                                color="#3b76b2" fontWeight={700} margin={'1rem'}
                            />
                        </Box>
                    </Box>
                    <Box width={'100%'} padding={'1rem'} display={'flex'} justifyContent={'center'} sx={{backgroundColor: '#3b76b2'}} marginTop={'1rem'}>
                        <Typography variant="h4" color="#fff" fontStyle={'italic'}>"{ourTeam.drive_quote}"</Typography>
                    </Box>
                </Box>

                <Box width={'100%'}  display={'flex'} flexWrap={'wrap'} gap={'1rem'} margin={'4rem 0'} sx={{maxWidth: {xs: '95%', sm: '95%', md: '1200px'},}}>
                    <Box boxShadow={2} flex={1} minWidth={'300px'} sx={{backgroundColor: '#32a059'}} borderRadius={'.5rem'} padding={'2rem'} marginTop={{xs: '1rem', sm: 'none'}}>
                        <Typography 
                            sx={{
                                padding: '1rem',
                                background: 'linear-gradient( to right, #fff, transparent)',
                                textTransform: 'uppercase',
                                color: '#000000ff'
                            }}
                            fontWeight={700}
                        >Areas of Knowledge</Typography>
                        <Typography dangerouslySetInnerHTML={{ __html: ourTeam.knowledge }} 
                            color="#fff" fontWeight={700} margin={'1rem'}
                        />
                    </Box>
                    <Box flex={1} minWidth={'300px'} sx={{backgroundColor: '#32a059'}} borderRadius={'.5rem'} padding={'2rem'} marginTop={{xs: '1rem', sm: 'none'}}>
                        <Typography 
                            sx={{
                                padding: '1rem',
                                background: 'linear-gradient( to right, #ffffffff, transparent)',
                                textTransform: 'uppercase'
                            }}
                            fontWeight={700}
                        >Values</Typography>
                        <Typography dangerouslySetInnerHTML={{ __html: ourTeam.core_values }} 
                            color="#fff" fontWeight={700} margin={'1rem'}
                        />
                    </Box>
                    <Box flex={1} minWidth={'300px'} sx={{backgroundColor: '#32a059'}} borderRadius={'.5rem'} padding={'2rem'} marginTop={{xs: '1rem', sm: 'none'}}>
                        <Typography 
                            sx={{
                                padding: '1rem',
                                background: 'linear-gradient( to right, #ffffffff, transparent)',
                                textTransform: 'uppercase'
                            }}
                            fontWeight={700}
                        >Areas Of Focus</Typography>
                        <Typography dangerouslySetInnerHTML={{ __html: ourTeam.focus }} 
                            color="#fff" fontWeight={700} margin={'1rem'}
                        />
                    </Box>
                </Box>

                {/* Other members
                <Box width={"100%"} maxWidth={"1200px"}>
                    <Box width={"100%"} sx={{
                        display: "flex", flexDirection: "column",
                        alignItems: "end",
                        justifyContent: "end",
                        borderBottom: '.1rem solid #90ca25'
                    }}>
                        <Typography variant="h5" sx={{
                            backgroundColor: "#90ca25",
                            padding: "1rem",
                            color: "#fff"
                        }}>Other Members</Typography>
                    </Box>
                    <Box sx={{
                        display: "flex", height: "auto", width: "auto", overflowX: "auto", gap: 1, 
                        justifyContent: "start", padding: '1rem' 
                    }}>
                        {allTeam.length > 0 && (
                            allTeam.map(team =>(
                                <Box key={team.Id} sx={{
                                    flexShrink: 0,
                                    width: "100px",
                                    height: "100px",
                                    overflow: "hidden",
                                    borderRadius: "50%",
                                    backgroundColor: "#90ca25"
                                }}>
                                    {team.Id != params && (
                                        <ButtonBase sx={{
                                            width: "100%", height: "100%"
                                        }} href={`/about/profile/?ui=${team.Id}`}>
                                            <Box sx={{ width: "100%", height: "100%" }}>
                                                <img
                                                    alt={team.FirstName}
                                                    src={`https://mindsinaction.com.na/assets/media/pictures/${team.image}`}
                                                    style={{
                                                    height: "100%"
                                                    }}
                                                />
                                            </Box>
                                        </ButtonBase>
                                    )}
                                </Box>
                            ))
                        )}
                    </Box>
                </Box> */}
            </div>
            {/* Footer */}
            <Footer />
        </>
    );
};

export default UserProfile;